import axios from "."
import queryString from "query-string"

export default {
  newConverstaion,
  fetchBulkSendUsers
}

async function newConverstaion(query = null) {
  let url = '/api/users/new-conversation'
  if (query) {
    url += `?${queryString.stringify(query)}`
  }
  const response = await axios.get(url)
  return response.data
}

async function fetchBulkSendUsers(association) {
  const response = await axios.get(`/api/users/${association}`)
  return response.data
}
